The subscriber-owned URL where events will be sent to.
